import {
	VERIFYQRCODEOTP_SUCCESS,
	VERIFYQRCODEOTP_FAILED,
	RESET_VERIFYQRCODEOTP,
	LOADING_VERIFYQRCODEOTP,
	NETWORK_ERROR_VERIFYQRCODEOTP
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_VERIFYQRCODEOTP:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case VERIFYQRCODEOTP_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case VERIFYQRCODEOTP_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_VERIFYQRCODEOTP:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_VERIFYQRCODEOTP:
			return (state = initialState);
		default:
			return state;
	}
};
